import { render, staticRenderFns } from "./RowBlockBonusSystem.vue?vue&type=template&id=6ba6a8ae&"
import script from "./RowBlockBonusSystem.vue?vue&type=script&lang=js&"
export * from "./RowBlockBonusSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports